import { useHasPermission } from '@hooks';
import { Permission } from '@common/utils/admin_permissions';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { ElementType } from 'react';
import { Tooltip } from '@mui/material';

export interface PermissionButtonProps extends LoadingButtonProps {
  permissions: Permission[];
  component?: ElementType;
  to?: string;
  tooltipText?: string;
}

export default function PermissionButton({
  permissions,
  disabled,
  loading,
  tooltipText = 'You are unauthorized to perform this action',
  ...buttonProps
}: PermissionButtonProps) {
  const hasPermission = useHasPermission(permissions);

  const button = <LoadingButton {...buttonProps} loading={loading} disabled={disabled || !hasPermission} />;

  if (!hasPermission) {
    return (
      <Tooltip title={tooltipText}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
}
